import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], filter: any): any {
    if(!items || !filter?.value) {
      return items;
    }
    return items.filter(item => item[filter['key']].indexOf(filter['value'])  !== -1);
  }
}
